import React, { Component } from 'react';
import AllocateForm from './AllocateForm';
import ReturnForm from './ReturnForm';
import axios from 'axios'
import { Loader } from 'monday-ui-react-core';
import { Button, TextField, Flex, ModalFooter, ModalContent, Modal } from 'monday-ui-react-core';
import env from "react-dotenv";
let baseUrl = process.env.REACT_APP_SERVER_URL;


export default class AssetRequestHandle extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: '',
            description: '',
            assetId: '',
            assetName: '',
            requests:[],
            isManagerIdPresent:true,
            recievedResponse:0,
            isloading:true,
            managerData:'',
            userId:this.props.userId,
            workSpaceId:this.props.workSpaceId,
            managerIds:''
        }
    }

    async componentDidMount() {
        if (localStorage.getItem("managerId")) {
            this.setState({
                managerId: localStorage.getItem("managerId")
            })
        }
        else {
            this.setState({
                isManagerIdPresent: false
            })
        }
        await this.mondayListenProcess();

    }

    setManagerId = () => {
        localStorage.setItem("managerId", this.state.managerData);
        this.setState({
            isManagerIdPresent: true
        })
        window.location.reload()
    }

    onChangeManagerData = (eventManagerData) => {
        this.setState({
            managerData: eventManagerData
        })
    }

    mondayListenProcess = async () => {
        
        let assetId = window.location.search
        assetId = assetId.split('&')
        assetId = assetId[0].split('=')
        let param = {
            "assetId": assetId[1],
            "managerId": localStorage.getItem("managerId")
        }
        await axios.get(`${baseUrl}/fetch-asset`,{params:param})
        .then((data)=>{
            this.setState( {
                status: data.data.status,
                description: data.data.description,
                assetId: assetId[1],
                assetName: data.data.name,
            })

        })
        .catch((err)=>{
            this.setState({isManagerIdPresent:false})
        })

        let requestParams = {
            "workSpaceId": this.state.workSpaceId,
            // "userId":this.state.userId,
            "managerId": localStorage.getItem("managerId")
        }
        this.setState({
            managerIds:localStorage.getItem('managerId')
        })
        await axios.get(`${baseUrl}/fetch-requests`,{params:requestParams})
        .then((data)=>{
            console.log("Fetch requets data",data?.data)
            if(data.length!==0){
                let reqOptions = []
                if(data.data.length!==0){
                    data.data.forEach((request)=>{
                        let assetType = request.column_values.find((column)=>column.id==="status_1")?.text;
                        let requestType = request.column_values.find((column)=>column.id==="status_12")?.text;
                        let info = request.column_values.find((column)=>column.id==="status")?.text;
                        console.log("Asset type",assetType,"Request type",requestType,"Status","info",info)
                        if(info!=null){
                            // let info = request.column_values[3].text;
                            if(info!="Approved" && info!="Rejected"){
                                console.log("Inside 1")
                                if(assetType=="Physical" && (this.state.status == 'Active' && requestType=='Request') || (this.state.status == 'In Use' && requestType=='Return')){               
                                reqOptions.push({
                                    label:`${request.id} -- ${request.name}`,
                                    value:request.id
                            })
                            }
                            }
                        }
                        else if(info == null || info == ""){
                            console.log("Inside 2")
                            
                            if(assetType=="Physical" && (this.state.status == 'Active' && requestType=='Request') || (this.state.status == 'In Use' && requestType=='Return')){
                            reqOptions.push({
                                label:`${request.id} -- ${request.name}`,
                                value:request.id
                        })
                    }
                        }
    
                    })
                    return reqOptions
                }

                }
                
            
        })
        .then((data)=>{
            this.setState( {
                requests:data,
                isloading:false
            })
        })
        .catch((err)=>{
            this.setState({
                isManagerIdPresent:false,
                isloading:false
            })
        })
    }
    render() {
        const { assetName, status, assetId,managerIds, description, requests, isManagerIdPresent,isloading } = this.state;
        
        return (
            <div >
                                    {isloading ?
                        <div className='loader'>
                            <Loader color="var(--primary-color)" hasBackground size={64} />
                        </div> :
                        <>
                {

                    status === "Active" ?
                        <div >
                            <AllocateForm assetName={assetName} status={status} assetId={assetId} description={description} requests={requests} isManagerIdPresent={isManagerIdPresent} />
                        </div> : null
                }
                {
                    status === "In Use" ?
                        <div>
                            <ReturnForm assetName={assetName} status={status} assetId={assetId} description={description} requests={requests} isManagerIdPresent={isManagerIdPresent} />
                        </div> : null
                }
                                <div>
                    <Modal
                        id="story-book-modal"
                        onClose={false}
                        title="Please fill the details below"
                        triggerElement={null}
                        show={!this.state.isManagerIdPresent}
                    >
                        <ModalContent>
                        {
                            managerIds!==null?
                            <div style={{color:'red'}}>
                                Enter a valid Manager ID
                            </div>:null
                        }
                            <TextField
                                title="Asset Manager Id"
                                id="managerId"
                                onChange={this.onChangeManagerData}
                                value={this.state.managerData}
                                wrapperClassName="monday-storybook-text-field_size"
                            />
                        </ModalContent>
                        <ModalFooter>
                            <Flex

                                gap={12}
                                justify="End"
                            >
                                <Button onClick={this.setManagerId}>
                                    Submit
                                </Button>
                            </Flex>
                        </ModalFooter>
                    </Modal>
                </div>
</>}
            </div>
        )
    }
}
